import React from 'react';
import { ProfileType } from '../../../../types/profileTypes';

interface ProfileTypeSelectorProps {
  value: ProfileType | '';
  onChange: (type: ProfileType) => void;
}

const ProfileTypeSelector: React.FC<ProfileTypeSelectorProps> = ({ value, onChange }) => (
  <div className="flex gap-2">
    <button
      type="button"
      onClick={() => onChange('musician')}
      className={`flex-1 rounded-md px-4 py-2 text-sm font-medium transition-colors duration-200 ${
        value === 'musician'
          ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white hover:from-pink-600 hover:to-purple-700'
          : 'bg-gray-100 text-gray-900 hover:bg-gray-200 dark:bg-neutral-800 dark:text-white dark:hover:bg-neutral-700'
      }`}
    >
      Musician 🎸
    </button>
    <button
      type="button"
      onClick={() => onChange('venue')}
      className={`flex-1 rounded-md px-4 py-2 text-sm font-medium transition-colors duration-200 ${
        value === 'venue'
          ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white hover:from-pink-600 hover:to-purple-700'
          : 'bg-gray-100 text-gray-900 hover:bg-gray-200 dark:bg-neutral-800 dark:text-white dark:hover:bg-neutral-700'
      }`}
      disabled={true}
    >
      Venue 🏢
    </button>
  </div>
);

export default ProfileTypeSelector;
